{
  "name": "client",
  "version": "5.1.9",
  "private": true,
  "description": "",
  "browser": {
    "ClientConfig": "./client/app/scripts/ClientConfig.js",
    "ClientConstants": "./client/app/scripts/ClientConstants.js",
    "DocumentUpdater": "./shared/data/DocumentUpdater.js",
    "LocalStorageKeys": "./client/app/scripts/constants/LocalStorageKeys.js",
    "Logger": "./client/app/scripts/modules/core/utils/Logger.js",
    "SearchResultsProcessor": "./shared/utils/SearchResultsProcessor.js",
    "UtilArray": "./shared/utils/UtilArray.js",
    "UtilConflict": "./shared/utils/UtilConflict.js",
    "UtilDocument": "./shared/utils/UtilDocument.js",
    "UtilDocumentId": "./shared/utils/UtilDocumentId.js",
    "UtilError": "./shared/utils/UtilError.js",
    "UtilHttpStatus": "./shared/utils/UtilHttpStatus.js",
    "UtilMap": "./client/app/scripts/modules/core/utils/UtilMap.js",
    "UtilSystemHeader": "./shared/utils/UtilSystemHeader.js",
    "crypto": false,
    "forever-agent": false,
    "fs": false,
    "http": false,
    "https": false,
    "net": false,
    "path": false,
    "stream": false,
    "tls": false,
    "tough-cookie": false,
    "zlib": false
  },
  "scripts": {
    "ng": "ng",
    "start": "gulp dev",
    "test": "CI=true ng test client --no-watch",
    "test-watch": "CI=true ng test client",
    "test-headed": "ng test client",
    "build": "node build.js",
    "lint": "ng lint client",
    "server": "NODE_ENV=test WEB_APP_SERVER=test node server/ServerApp.js",
    "server:e2e": "gulp test-e2e --server-only --server-logs --no-dist-build",
    "pw": "rm -rf playwright-screenshots junit-reports/playwright && pnpm exec playwright test",
    "pw-ui": "rm -rf playwright-screenshots junit-reports/playwright && pnpm exec playwright test --ui",
    "pretest": "tsc --incremental -p tsconfig.spec.json"
  },
  "author": "Formbird",
  "license": "SEE LICENSE in LICENSE",
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "2.3.1",
    "@fontsource/roboto": "^4.5.3",
    "@formbird/indexed-db": "workspace:*",
    "@formbird/services": "workspace:*",
    "@formbird/shared": "workspace:*",
    "@formbird/types": "workspace:*",
    "@ng-select/ng-select": "21.0.0",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "24.3.1",
    "@vitest/browser": "^4.1.10",
    "buffer": "5.2.1",
    "del": "8.0.1",
    "device-detect": "1.0.7",
    "dexie": "4.2.0",
    "immer": "9.0.12",
    "mongobackup": "0.1.8",
    "ng-packagr": "21.0.1",
    "ngx-infinite-scroll": "20.0.0",
    "notyf": "^3.6.0",
    "papaparse": "4.6.3",
    "prettier": "1.18.2",
    "redux": "4.0.1",
    "require-dir": "1.0.0",
    "rxjs": "7.8.2",
    "semver": "5.3.0",
    "socket.io-client": "4.4.1",
    "tail": "0.4.0",
    "tslib": "2.8.1",
    "typescript": "~5.9.3",
    "util": "^0.12.5",
    "vite-tsconfig-paths": "5.1.4",
    "vitest": "^4.1.10",
    "workbox-build": "^7.3.0",
    "yargs": "3.29.0",
    "zone.js": "0.15.1"
  },
  "dependencies": {
    "@elastic/elasticsearch": "7.6.1",
    "async": "1.4.2",
    "bson": "^5.2.0",
    "es-toolkit": "1.39.10",
    "fflate": "^0.8.2",
    "file-saver": "^2.0.5",
    "global": "^4.4.0",
    "handlebars": "4.7.8",
    "jsonpath-plus": "^5.0.4",
    "loadjs": "^4.3.0",
    "lodash": "^4.17.15",
    "material-icons": "1.13.12",
    "method-override": "*",
    "mime-types": "3.0.2",
    "moment": "2.30.1",
    "mongodb": "7.4.0",
    "morgan": "1.10.0",
    "multer": "^1.4.2",
    "netmask": "^2.0.2",
    "ngx-lightbox": "^3.0.0",
    "node-7z": "^1.1.0",
    "node-rest-client": "^3.1.0",
    "nodemailer": "^6.9.7",
    "passport": "0.6.0",
    "passport-google-oauth": "^2.0.0",
    "passport-local": "1.0.0",
    "passport-saml": "3.2.4",
    "pdfkit": "^0.11.0",
    "piexifjs": "^1.0.6",
    "pm2": "^7.0.3",
    "q": "1.4.1",
    "rfc6902": "^3.0.4",
    "socket.io": "4.4.1",
    "uuid": "8.2.0"
  }
}
